import React from 'react';
import SectionMessage from '@atlaskit/section-message';

import { OptionItemObject } from '../../../../../src/shared_models/interfaces';

import { OptionDisabledWarningProperties } from './interfaces';
import { OptionDisabledWarningWrapper as Wrapper } from './styles';

const SECTION_TITLE = 'This select won\'t be visible';

const renderWarningMessage = (disabledOption: OptionItemObject | undefined) => `Option ${disabledOption!.value} from Level ${disabledOption!.depth! + 1}
    is disabled. It means that users won't be able to see or select it. Therefore, the underlying options won't be visible and available for them.
`;

const OptionDisabledWarning: React.FC<OptionDisabledWarningProperties> = ({ disabledOption }) => (
    <Wrapper>
        <SectionMessage title={SECTION_TITLE} appearance="warning">
            <p>{renderWarningMessage(disabledOption)}</p>
        </SectionMessage>
    </Wrapper>
);

export default OptionDisabledWarning;
